import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAProduct, addTowishlist } from '../features/products/productSlice';
import { getUserCart, addProdToCart, syncLocalCart } from '../features/user/userSlice';
import { base_url } from '../utils/axiosConfig';
import { Container } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import {
  FaArrowLeft, FaHeart, FaShoppingCart, FaBolt,
  FaMinus, FaPlus, FaTrash, FaCheckCircle,
  FaStar, FaRegHeart, FaTag, FaShieldAlt, FaUndo, FaTruck, FaTimesCircle
} from 'react-icons/fa';
import RelatedProducts from '../components/RelatedProducts';

const showToast = (type, message, subtext) => {
  const isSuccess = type === 'success';
  toast.custom((t) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        background: '#fff',
        border: `1px solid ${isSuccess ? '#d1fae5' : '#fee2e2'}`,
        borderLeft: `4px solid ${isSuccess ? '#10b981' : '#ef4444'}`,
        borderRadius: '12px',
        padding: '12px 16px',
        minWidth: '260px',
        maxWidth: '340px',
        opacity: t.visible ? 1 : 0,
        transform: t.visible ? 'translateY(0)' : 'translateY(-12px)',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        zIndex: 9999,
      }}
      onClick={() => toast.dismiss(t.id)}
    >
      <div style={{
        width: 36, height: 36, borderRadius: '50%',
        background: isSuccess ? '#d1fae5' : '#fee2e2',
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
      }}>
        {isSuccess
          ? <FaCheckCircle color="#10b981" size={18} />
          : <FaTimesCircle color="#ef4444" size={18} />}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, fontSize: '14px', color: '#111', lineHeight: 1.3 }}>{message}</div>
        {subtext && <div style={{ fontSize: '11px', color: '#6b7280', marginTop: 2 }}>{subtext}</div>}
      </div>
    </div>
  ), { duration: 2500 });
};

// Add FaTimesCircle to the imports

/* ΓöÇΓöÇ Constants ΓöÇΓöÇ */
const FONT = '"Rubik", "Poppins", sans-serif';
const ORANGE = '#ff6701';
const DARK = '#232f3e';
const ZOOM_FACTOR = 2.8;   // how much to magnify
const ZOOM_SIZE = 380;   // width & height of zoom panel in px

const SingleProduct = () => {
  /* ΓöÇΓöÇ UI state ΓöÇΓöÇ */
  const [quantity, setQuantity] = useState(1);
  const [mainImage, setMainImage] = useState('');
  const [alreadyAdded, setAlreadyAdded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cartItem, setCartItem] = useState(null);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [activeTab, setActiveTab] = useState('description');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [units, setUnits] = useState([]);

  /* ΓöÇΓöÇ Zoom state ΓöÇΓöÇ */
  const mainImgRef = useRef(null);
  const [hoverPos, setHoverPos] = useState(null); // { x%, y% } inside image
  const [zoomRect, setZoomRect] = useState(null); // DOMRect of main image

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const productId = location.pathname.split('/')[2];

  const productState = useSelector(s => s.product.singleProduct);
  const { isAuthenticated, cartProducts, user, wishlist } = useSelector(s => s.auth);
  const role = user?.role || JSON.parse(localStorage.getItem('customer'))?.role;

  /* ΓöÇΓöÇ Resize ΓöÇΓöÇ */
  useEffect(() => {
    const fn = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);

  /* ΓöÇΓöÇ Fetch ΓöÇΓöÇ */
  useEffect(() => {
    const fetchUnits = async () => {
      try {
        const res = await axios.get(`${base_url}unit/`);
        setUnits(res.data);
      } catch (err) {
        console.error("Error fetching units", err);
      }
    };
    fetchUnits();

    dispatch(getAProduct(productId));
    if (isAuthenticated) dispatch(getUserCart());
  }, [dispatch, productId, isAuthenticated]);

  useEffect(() => {
    if (productState?.images?.length > 0)
      setMainImage(`${base_url}${productState.images[0]?.url}`);
    if (productState?.variants?.length > 0)
      setSelectedVariant(productState.variants[0]);
  }, [productState]);

  useEffect(() => {
    if (!productState?._id) return;
    const cart = isAuthenticated
      ? (cartProducts || [])
      : (JSON.parse(localStorage.getItem('cart')) || []);
    const variantId = selectedVariant?._id;
    const variantStr = selectedVariant?.measurementUnit;
    const found = cart.find(i => 
      i?.ProductId?._id === productState._id && 
      (i.variantId === variantId || i.variant === variantStr)
    );
    setCartItem(found || null);
    setQuantity(found?.quantity || 1);
    setAlreadyAdded(!!found);
    if (Array.isArray(wishlist))
      setIsWishlisted(wishlist.some(i => i._id === productState._id));
  }, [cartProducts, isAuthenticated, productState, wishlist, selectedVariant]);

  /* ΓöÇΓöÇ Hover zoom handlers ΓöÇΓöÇ */
  const handleMouseMove = useCallback((e) => {
    if (!mainImgRef.current) return;
    const rect = mainImgRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
    const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
    setHoverPos({ x, y });
    setZoomRect(rect);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHoverPos(null);
    setZoomRect(null);
  }, []);

  /* ΓöÇΓöÇ Derived zoom lens position ΓöÇΓöÇ */
  const LENS = 100; // px
  const lensStyle = hoverPos ? {
    position: 'absolute',
    width: LENS, height: LENS,
    left: `calc(${hoverPos.x}% - ${LENS / 2}px)`,
    top: `calc(${hoverPos.y}% - ${LENS / 2}px)`,
    border: `2px solid ${ORANGE}`,
    borderRadius: 4,
    backgroundColor: 'rgba(255,103,1,0.08)',
    pointerEvents: 'none',
    zIndex: 5,
  } : null;

  /* ΓöÇΓöÇ Wishlist ΓöÇΓöÇ */
  const handleWishlist = async () => {
    if (!isAuthenticated) { showToast('error', 'Login Required', 'Please login to add to wishlist'); return; }
    if (role === 'deliveryboy') { showToast('error', 'Action Restricted', 'Delivery boys cannot wishlist products.'); return; }
    try {
      await dispatch(addTowishlist(productState._id)).unwrap();
      const wasWishlisted = isWishlisted;
      setIsWishlisted(!isWishlisted);
      showToast('success', 
        wasWishlisted ? 'Removed from Wishlist' : 'Added to Wishlist', 
        wasWishlisted ? 'Product removed successfully' : 'Product saved for later'
      );
    } catch { showToast('error', 'Update Failed', 'Failed to update wishlist. Please try again.'); }
  };

  /* Handle Add to Cart */
  const handleAddToCart = async () => {
    if (role === 'deliveryboy') { 
        showToast('error', 'Action Restricted', 'Delivery boys cannot add to cart.'); 
        return; 
    }
    
    setLoading(true);

    const price = selectedVariant
      ? (selectedVariant.offerPrice > 0 ? selectedVariant.offerPrice : selectedVariant.CurrentPrice)
      : (productState?.offerPrice > 0 ? productState.offerPrice : productState?.CurrentPrice);

    const variantId = selectedVariant?._id;
    const variantStr = selectedVariant?.measurementUnit || "";
    
    // ✅ Get unit title (e.g., "Kg" or "Gram")
    const unitTitle = selectedVariant?.unit?.title || 
                     (productState?.variants?.[0]?.unit?.title) || "";

    if (!isAuthenticated) {
      const local = JSON.parse(localStorage.getItem('cart')) || [];
      
      const idx = local.findIndex(i => 
        i.ProductId._id === productState._id && 
        (i.variantId === variantId || i.variant === variantStr)
      );

      if (idx !== -1) {
        local[idx].quantity += quantity;
      } else {
        local.push({
          _id: `${productState._id}_${variantId}_${Date.now()}`,
          ProductId: {
            _id: productState._id,
            title: productState.title,
            images: productState.images
          },
          variantId,
          variant: variantStr,
          measurementUnit: variantStr,
          unitTitle,                    // ← Added
          unitName: unitTitle,          // ← Optional: more readable name
          quantity,
          price,
          gst: productState.gst || 0
        });
      }

      localStorage.setItem('cart', JSON.stringify(local));
      dispatch(syncLocalCart(local));
      
      showToast('success', 'Added to Cart', 
        `${productState?.title?.slice(0, 30)}${productState?.title?.length > 30 ? '…' : ''}`
      );
      
      setAlreadyAdded(true);
      setLoading(false);
      return;
    }

    // Authenticated user flow (also good to send unitTitle to backend)
    try {
      const payload = {
        ProductId: {
          _id: productState._id,
          title: productState.title,
          images: productState.images,
          price
        },
        variantId,
        variant: variantStr,
        measurementUnit: variantStr,
        unitTitle,                    // ← Also send to backend if needed
        quantity: cartItem ? cartItem.quantity + quantity : quantity,
        price
      };

      await dispatch(addProdToCart(payload)).unwrap();
      dispatch(getUserCart());
      
      showToast('success', 'Added to Cart', 
        `${productState?.title?.slice(0, 30)}${productState?.title?.length > 30 ? '…' : ''}`
      );
      
      setAlreadyAdded(true);
    } catch {
      showToast('error', 'Failed to add', 'Please try again.');
    } finally {
      setLoading(false);
    }
};

  const handleBuyNow = async () => {
    if (role === 'deliveryboy') { showToast('error', 'Action Restricted', 'Delivery boys cannot purchase products.'); return; }
    await handleAddToCart();
    navigate('/cart');
  };

  const updateQtyLocal = (n) => {
    const variantId = selectedVariant?._id;
    const local = (JSON.parse(localStorage.getItem('cart')) || []).map(i =>
      (i.ProductId._id === productState._id && (i.variantId === variantId || i.variant === selectedVariant?.measurementUnit)) ? { ...i, quantity: n } : i);
    localStorage.setItem('cart', JSON.stringify(local));
    dispatch(syncLocalCart(local));
    setQuantity(n);
  };

  const updateQtyAPI = async (n) => {
    try {
      const token = JSON.parse(localStorage.getItem('customer'))?.token;
      await axios.put(`${base_url}user/updatecart`,
        { 
          cartItemId: cartItem?._id,
          ProductId: productState._id, 
          variantId: selectedVariant?._id, 
          variant: selectedVariant?.measurementUnit,
          quantity: n, 
          price: finalPrice 
        },
        { headers: { Authorization: `Bearer ${token}` } });
      dispatch(getUserCart());
    } catch { showToast('error', 'Update Failed', 'Failed to update quantity. Please try again.'); }
  };

  const increase = () => {
    if (role === 'deliveryboy') return;
    const n = quantity + 1; setQuantity(n);
    isAuthenticated ? updateQtyAPI(n) : updateQtyLocal(n);
  };

  const decrease = () => {
    if (role === 'deliveryboy') return;
    const n = Math.max(1, quantity - 1); setQuantity(n);
    isAuthenticated ? updateQtyAPI(n) : updateQtyLocal(n);
  };

  const handleRemove = async (itemId) => {
    if (role === 'deliveryboy') return;
    if (isAuthenticated) {
      try {
        const token = JSON.parse(localStorage.getItem('customer'))?.token;
        await axios.delete(`${base_url}user/delete-product-cart`, {
          headers: { Authorization: `Bearer ${token}`, Accept: 'application/json', 'Content-Type': 'application/json' },
          data: { cartItemId: itemId },
        });
        showToast('success', 'Removed from Cart', 'Item has been removed.'); 
        dispatch(getUserCart()); setAlreadyAdded(false);
      } catch { showToast('error', 'Remove Failed', 'Error removing item. Please try again.'); }
    } else {
      const updated = (JSON.parse(localStorage.getItem('cart')) || []).filter(i => i._id !== itemId);
      localStorage.setItem('cart', JSON.stringify(updated));
      dispatch(syncLocalCart(updated));
      showToast('success', 'Removed from Cart', 'Item has been removed.');
      setAlreadyAdded(false);
    }
  };

  const currentPrice = selectedVariant ? selectedVariant.CurrentPrice : productState?.CurrentPrice;
  const offerPrice = selectedVariant ? selectedVariant.offerPrice : productState?.offerPrice;

  const finalPrice = offerPrice > 0 ? offerPrice : currentPrice;
  const hasOffer = offerPrice > 0;
  const discount = hasOffer
    ? Math.round(((currentPrice - offerPrice) / currentPrice) * 100)
    : 0;

  /* ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
     RENDER
  ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ */
  return (
    <div style={{ fontFamily: FONT, backgroundColor: '#f5f5f7', minHeight: '100vh' }}>
      <Toaster position="top-center" />

      <Container style={{ maxWidth: 1200, padding: isMobile ? '12px 12px 40px' : '24px 16px 60px' }}>

        {/* Back */}
        <button onClick={() => navigate(-1)} style={s.backBtn}>
          <FaArrowLeft size={13} style={{ marginRight: 6 }} />Back
        </button>

        {/* ΓòÉΓòÉΓòÉ Main product grid ΓòÉΓòÉΓòÉ */}
        <div style={{ ...s.productGrid, gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr' }}>

          {/* ΓöÇΓöÇ LEFT: gallery ΓöÇΓöÇ */}
          <div style={s.galleryCol}>

            {/* Thumbnail strip (vertical on desktop) + main image */}
            <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 10 }}>

              {/* Vertical thumbnails */}
              {!isMobile && productState?.images?.length > 1 && (
                <div style={s.thumbStrip}>
                  {productState.images.map((img, i) => {
                    const url = `${base_url}${img?.url}`;
                    const active = mainImage === url;
                    return (
                      <div
                        key={i}
                        onClick={() => setMainImage(url)}
                        style={{
                          ...s.thumb,
                          borderColor: active ? ORANGE : '#e0e0e0',
                          boxShadow: active ? `0 0 0 2px ${ORANGE}` : 'none',
                        }}
                      >
                        <img src={url} alt={`thumb-${i}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Main image */}
              <div style={{ flex: 1, position: 'relative' }}>
                <div
                  ref={mainImgRef}
                  style={{
                    ...s.mainImgWrap,
                    cursor: !isMobile ? 'crosshair' : 'zoom-in',
                  }}
                  onMouseMove={!isMobile ? handleMouseMove : undefined}
                  onMouseLeave={!isMobile ? handleMouseLeave : undefined}
                >
                  {/* Discount badge */}
                  {hasOffer && (
                    <div style={s.discountBadge}>
                      <FaTag size={9} style={{ marginRight: 3 }} />-{discount}% OFF
                    </div>
                  )}

                  {/* Wishlist button */}
                  <button
                    onClick={(e) => { e.stopPropagation(); handleWishlist(); }}
                    style={s.heartBtn}
                  >
                    {isWishlisted
                      ? <FaHeart color="#ef4444" size={18} />
                      : <FaRegHeart color="#aaa" size={18} />}
                  </button>

                  {/* Product image */}
                  {mainImage
                    ? <img src={mainImage} alt={productState?.title} style={s.mainImg} />
                    : <div style={s.imgPlaceholder}><FaShoppingCart size={48} color="#e0e0e0" /></div>
                  }

                  {/* Lens overlay */}
                  {!isMobile && lensStyle && <div style={lensStyle} />}
                </div>

                {/* Hover hint */}
                {!isMobile && (
                  <p style={s.zoomHint}>
                    {hoverPos ? '≡ƒöì Zoomed view ΓåÆ' : 'Hover image to zoom'}
                  </p>
                )}
              </div>
            </div>

            {/* Mobile thumbnails (horizontal scroll) */}
            {isMobile && productState?.images?.length > 1 && (
              <div style={s.mobileThumbRow}>
                {productState.images.map((img, i) => {
                  const url = `${base_url}${img?.url}`;
                  const active = mainImage === url;
                  return (
                    <div
                      key={i}
                      onClick={() => setMainImage(url)}
                      style={{ ...s.thumb, borderColor: active ? ORANGE : '#e0e0e0', boxShadow: active ? `0 0 0 2px ${ORANGE}` : 'none' }}
                    >
                      <img src={url} alt={`t${i}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                  );
                })}
              </div>
            )}

            {/* Trust badges */}
            <div style={s.trustRow}>
              {[
                { icon: <FaTruck color={ORANGE} size={13} />, text: 'Free Delivery' },
                { icon: <FaUndo color={ORANGE} size={13} />, text: 'Easy Returns' },
                { icon: <FaShieldAlt color={ORANGE} size={13} />, text: '100% Genuine' },
              ].map(({ icon, text }) => (
                <div key={text} style={s.trustItem}>{icon}<span style={{ fontSize: 11, color: '#666', marginLeft: 5 }}>{text}</span></div>
              ))}
            </div>
          </div>

          <div style={s.infoCol}>
            {productState?.brand && <p style={s.brand}>{productState.brand}</p>}

            <h1 style={{ ...s.title, fontSize: isMobile ? 18 : 20 }}>{productState?.title}</h1>

            {/* Stars */}
            <div style={s.ratingRow}>
              {[1, 2, 3, 4, 5].map(n => (
                <FaStar key={n} size={13} color={n <= 4 ? '#f59e0b' : '#e0e0e0'} />
              ))}
              <span style={s.ratingText}>4.0</span>
              <span style={s.ratingCount}>(1,200 ratings)</span>
            </div>

            <div style={s.divider} />

            {/* Price */}
            <div style={s.priceBlock}>
              <span style={s.finalPrice}>₹{finalPrice?.toLocaleString('en-IN')}</span>
              {hasOffer && (
                <>
                  <span style={s.strikePrice}>₹{currentPrice?.toLocaleString('en-IN')}</span>
                  <span style={s.saveBadge}>Save ₹{((currentPrice || 0) - (offerPrice || 0))?.toLocaleString('en-IN') || '0'}</span>
                </>
              )}
            </div>
            {productState?.gst > 0 && (
              <p style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>Inclusive of all taxes ({productState.gst}% GST)</p>
            )}
            <div style={s.divider} />

            {/* Variants */}
            {productState?.variants?.length > 0 && (
              <div style={{ marginBottom: 18 }}>
                <p style={{ fontSize: 13, fontWeight: 700, color: '#444', marginBottom: 10 }}>Select Weight / Unit:</p>
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                  {productState.variants.map((v, i) => {
                    const active = selectedVariant?._id === v._id;
                    const unitVal = v.unit;
                    const unitId = typeof unitVal === 'object' ? unitVal?._id : unitVal;
                    const unitObj = units.find(u => String(u._id) === String(unitId));
                    const variantUnitTitle = v.title || (typeof unitVal === 'object' && unitVal?.title) || unitObj?.title || "";
                    
                    return (
                      <button
                        key={v._id || i}
                        onClick={() => setSelectedVariant(v)}
                        style={{
                          ...s.variantBtn,
                          backgroundColor: active ? ORANGE : '#fff',
                          color: active ? '#fff' : '#444',
                          borderColor: active ? ORANGE : '#e0e0e0',
                        }}
                      >
                        {v.measurementUnit} {variantUnitTitle}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            <div style={s.divider} />

            {/* Stock */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 18 }}>
              <FaCheckCircle color="#10b981" size={13} />
              <span style={{ fontSize: 13, color: '#10b981', fontWeight: 600 }}>In Stock Ready to Ship</span>
            </div>

            {/* Cart actions */}
            {alreadyAdded ? (
              <div style={s.cartActions}>
                <div style={s.qtyStepper}>
                  <button onClick={decrease} style={s.qtyBtn}><FaMinus size={10} /></button>
                  <span style={s.qtyNum}>{quantity}</span>
                  <button onClick={increase} style={s.qtyBtn}><FaPlus size={10} /></button>
                  <button onClick={() => handleRemove(cartItem?._id)} style={{ ...s.qtyBtn, color: '#ef4444', marginLeft: 4 }}>
                    <FaTrash size={10} />
                  </button>
                </div>
                <button onClick={() => navigate('/cart')} style={{ ...s.actionBtn, backgroundColor: DARK, flex: 1 }}>
                  <FaShoppingCart size={14} style={{ marginRight: 6 }} />View Cart
                </button>
              </div>
            ) : (
              <div style={{ ...s.cartActions, flexDirection: isMobile ? 'column' : 'row' }}>
                <button onClick={handleAddToCart} disabled={loading} style={{ ...s.actionBtn, backgroundColor: DARK, flex: 1, opacity: loading ? 0.7 : 1 }}>
                  <FaShoppingCart size={14} style={{ marginRight: 6 }} />
                  {loading ? 'Adding' : 'Add to Cart'}
                </button>
                <button onClick={handleBuyNow} disabled={loading} style={{ ...s.actionBtn, backgroundColor: ORANGE, flex: 1, opacity: loading ? 0.7 : 1, boxShadow: '0 4px 14px rgba(255,103,1,0.35)' }}>
                  <FaBolt size={14} style={{ marginRight: 6 }} />
                  {loading ? 'Processing' : 'Buy Now'}
                </button>
              </div>
            )}

            <div style={s.divider} />

            {/* Description tabs */}
            <div style={s.tabs}>
              {['description', 'info'].map(tab => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  style={{
                    ...s.tabBtn,
                    color: activeTab === tab ? ORANGE : '#777',
                    borderBottom: activeTab === tab ? `2.5px solid ${ORANGE}` : '2.5px solid transparent',
                    fontWeight: activeTab === tab ? 700 : 500,
                  }}
                >
                  {tab === 'description' ? 'Description' : 'Additional Info'}
                </button>
              ))}
            </div>
            <p style={s.tabText}>
              {activeTab === 'description'
                ? (productState?.description || 'No description available.')
                : (productState?.remarks || 'No additional information.')}
            </p>
          </div>
        </div>

        {/* Related */}
        <div style={{ marginTop: 40 }}>
          <RelatedProducts currentProduct={productState} />
        </div>
      </Container>

      {/* ΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉ
          FLIPKART-STYLE ZOOM PANEL (fixed position)
      ΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉΓòÉ */}
      {!isMobile && hoverPos && zoomRect && mainImage && (
        <div
          style={{
            position: 'fixed',
            top: Math.max(10, zoomRect.top),
            left: zoomRect.right + 16,
            width: ZOOM_SIZE,
            height: Math.min(ZOOM_SIZE, zoomRect.height),
            backgroundImage: `url(${mainImage})`,
            backgroundSize: `${ZOOM_FACTOR * 100}%`,
            backgroundPosition: `${hoverPos.x}% ${hoverPos.y}%`,
            backgroundRepeat: 'no-repeat',
            border: '2px solid #e0e0e0',
            borderRadius: 14,
            boxShadow: '0 16px 48px rgba(0,0,0,0.18)',
            zIndex: 9998,
            pointerEvents: 'none',
            backgroundColor: '#fff',
          }}
        />
      )}
    </div>
  );
};

/* ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ Styles ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ */
const s = {
  backBtn: {
    display: 'inline-flex', alignItems: 'center',
    background: '#fff', border: '1.5px solid #e0e0e0', borderRadius: 8,
    padding: '7px 16px', fontSize: 13, fontWeight: 500, color: '#444',
    cursor: 'pointer', marginBottom: 20, fontFamily: FONT,
    boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
  },
  productGrid: {
    display: 'grid', alignItems: 'start', gap: 24,
    backgroundColor: '#fff', borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
    padding: 20, overflow: 'visible',
  },
  /* Gallery */
  galleryCol: { display: 'flex', flexDirection: 'column', gap: 12 },
  thumbStrip: { display: 'flex', flexDirection: 'column', gap: 8, paddingTop: 4 },
  thumb: {
    width: 54, height: 54, borderRadius: 8,
    overflow: 'hidden', border: '2px solid',
    cursor: 'pointer', transition: 'all 0.2s', flexShrink: 0,
    backgroundColor: '#f9fafb',
  },
  mobileThumbRow: { display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 4 },
  mainImgWrap: {
    position: 'relative',
    backgroundColor: '#f9fafb', borderRadius: 14,
    overflow: 'hidden', aspectRatio: '5 / 3',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    border: '1px solid #f0f0f0', userSelect: 'none',
  },
  mainImg: { width: '100%', height: '100%', objectFit: 'contain', display: 'block' },
  imgPlaceholder: { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 300 },
  discountBadge: {
    position: 'absolute', top: 12, left: 12, zIndex: 3,
    display: 'inline-flex', alignItems: 'center',
    padding: '4px 10px', borderRadius: 20,
    backgroundColor: '#ef4444', color: '#fff',
    fontSize: 11, fontWeight: 700,
  },
  heartBtn: {
    position: 'absolute', top: 12, right: 12, zIndex: 4,
    width: 36, height: 36, borderRadius: '50%',
    backgroundColor: '#fff', border: '1px solid #eee',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  zoomHint: {
    fontSize: 11, color: '#aaa', textAlign: 'center',
    marginTop: 6, marginBottom: 0, fontStyle: 'italic',
  },
  trustRow: {
    display: 'flex', gap: 12, justifyContent: 'center',
    padding: '10px 0', borderTop: '1px solid #f0f0f0', flexWrap: 'wrap',
  },
  trustItem: { display: 'flex', alignItems: 'center' },
  /* Info col */
  infoCol: { display: 'flex', flexDirection: 'column' },
  brand: { fontSize: 11, fontWeight: 700, color: ORANGE, textTransform: 'uppercase', letterSpacing: 1, margin: '0 0 4px' },
  title: { fontWeight: 800, color: '#1c1c1b', margin: '0 0 8px', lineHeight: 1.3 },
  ratingRow: { display: 'flex', alignItems: 'center', gap: 3, marginBottom: 12 },
  ratingText: { fontSize: 13, fontWeight: 700, color: '#1c1c1b', marginLeft: 6 },
  ratingCount: { fontSize: 12, color: '#aaa', marginLeft: 2 },
  divider: { height: 1, backgroundColor: '#f0f0f0', margin: '10px 0' },
  priceBlock: { display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' },
  finalPrice: { fontSize: 24, fontWeight: 800, color: DARK, letterSpacing: -0.5 },
  strikePrice: { fontSize: 16, color: '#aaa', textDecoration: 'line-through' },
  saveBadge: {
    display: 'inline-flex', alignItems: 'center',
    padding: '3px 10px', borderRadius: 20,
    backgroundColor: '#fef3c7', color: '#b45309',
    fontSize: 11, fontWeight: 700,
  },
  /* Cart */
  cartActions: { display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' },
  qtyStepper: {
    display: 'flex', alignItems: 'center',
    border: '1.5px solid #e0e0e0', borderRadius: 10, overflow: 'hidden',
    backgroundColor: '#fff',
  },
  qtyBtn: {
    padding: '10px 13px', background: 'none', border: 'none',
    cursor: 'pointer', color: '#555', fontSize: 13,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  qtyNum: { fontSize: 15, fontWeight: 700, color: DARK, padding: '0 12px', minWidth: 36, textAlign: 'center' },
  actionBtn: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    padding: '10px 18px', color: '#fff',
    border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 13,
    cursor: 'pointer', fontFamily: FONT, transition: 'opacity 0.2s',
  },
  /* Tabs */
  tabs: { display: 'flex', gap: 0, borderBottom: '1px solid #f0f0f0', marginBottom: 14 },
  tabBtn: {
    padding: '7px 14px', background: 'none', border: 'none',
    cursor: 'pointer', fontSize: 13, fontFamily: FONT, transition: 'all 0.2s',
  },
  tabText: { fontSize: 13, color: '#666', lineHeight: 1.8, margin: 0, minHeight: 60 },
  variantBtn: {
    padding: '8px 16px', borderRadius: 8, border: '1.5px solid',
    fontSize: 13, fontWeight: 600, cursor: 'pointer',
    transition: 'all 0.2s', fontFamily: FONT,
  },
};

export default SingleProduct;
